export default "__VITE_ASSET__CoEcfnj1__"